const SAMPLE_DOCUMENTS = [
  { id: 'd1', filename: 'PA_14_15_periapical.dcm', docType: 'xray', date: '2026-03-18', device: 'Dexis Sensor', tooth: '14', patient: 'Sarah Chen' },
  { id: 'd2', filename: 'Pano_FullArch_20260315.dcm', docType: 'xray', date: '2026-03-15', device: 'Planmeca ProMax', tooth: null, patient: 'Sarah Chen' },
  { id: 'd3', filename: 'CBCT_Implant_Site_36.dcm', docType: 'ctScan', date: '2026-03-14', device: 'CS 8200 3D', tooth: '36', patient: 'James Rivera' },
  { id: 'd4', filename: 'CBCT_Impacted_48.dcm', docType: 'ctScan', date: '2026-03-10', device: 'CS 8200 3D', tooth: '48', patient: 'Maria Lopez' },
  { id: 'd5', filename: 'UpperArch_Scan_v2.stl', docType: 'intraoral3d', date: '2026-03-17', device: 'iTero Element 5D', tooth: null, patient: 'Sarah Chen' },
  { id: 'd6', filename: 'LowerArch_Scan.stl', docType: 'intraoral3d', date: '2026-03-17', device: 'iTero Element 5D', tooth: null, patient: 'James Rivera' },
  { id: 'd7', filename: 'IntraoralPhoto_11_Fracture.jpg', docType: 'photo', date: '2026-03-18', device: 'DEXIS IXS Cam', tooth: '11', patient: 'Emily Tran' },
  { id: 'd8', filename: 'IntraoralPhoto_Occlusal_Upper.jpg', docType: 'photo', date: '2026-03-16', device: 'DEXIS IXS Cam', tooth: null, patient: 'Sarah Chen' },
  { id: 'd9', filename: 'BW_Left_Posterior.dcm', docType: 'xray', date: '2026-03-12', device: 'Dexis Sensor', tooth: '18-21', patient: 'Carlos Ortega' },
  { id: 'd10', filename: 'Consent_Form_Signed.pdf', docType: 'other', date: '2026-03-18', device: 'Upload', tooth: null, patient: 'Sarah Chen' }
]

const DOC_TABS = ['all', 'xray', 'ctScan', 'intraoral3d', 'photo']

export const documents = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'ink',
  color: 'inkText',

  TabInit: { display: 'none', show: (() => { let d = false; return (el, s) => { if (!d) { d = true; Promise.resolve().then(() => s.root.update({ activeTab: 'documents', docFilter: 'all' })) } return false } })() },

  NavSidebar: {},

  MainContent: {
    flow: 'y',
    flex: '1',
    overflow: 'auto',

    TopBar: {},

    ContentArea: {
      flow: 'y',
      gap: 'B',
      padding: 'B',
      flex: '1',
      '@mobileL': { padding: 'A' },

      // ─── PAGE HEADER ──────────────────────────
      PageHeader: {
        flow: 'x',
        align: 'center flex-start',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 'Z',

        HeaderLeft: {
          flow: 'y',
          gap: 'X',
          Title: { text: '{{ documents | polyglot }}', fontSize: 'C', fontWeight: '700', color: 'inkText' },
          Subtitle: { text: '{{ documentMgmtSubtitle | polyglot }}', fontSize: 'Z', color: 'inkMuted' }
        },

        UploadBtn: {
          extends: 'Button',
          text: '{{ uploadDocument | polyglot }}',
          fontSize: 'Z',
          padding: 'Z A',
          round: 'Z',
          background: 'teal',
          color: 'white',
          fontWeight: '600',
          cursor: 'pointer'
        }
      },

      // ─── DEVICE IMPORT PANEL ──────────────────
      DeviceImportPanel: {},

      // ─── FILTER TABS ──────────────────────────
      FilterTabs: {
        flow: 'x',
        gap: 'Y',
        flexWrap: 'wrap',

        AllTab: {
          text: '{{ all | polyglot }}',
          fontSize: 'Z',
          fontWeight: '600',
          padding: 'Y Z',
          round: 'Y',
          cursor: 'pointer',
          background: (el, s) => (s.root.docFilter || 'all') === 'all' ? 'inkText' : 'inkSurface',
          color: (el, s) => (s.root.docFilter || 'all') === 'all' ? 'inkMid' : 'inkMuted',
          on: { click: (e, el, s) => s.root.update({ docFilter: 'all' }) }
        },
        XrayTab: {
          text: '{{ xrays | polyglot }}',
          fontSize: 'Z',
          fontWeight: '600',
          padding: 'Y Z',
          round: 'Y',
          cursor: 'pointer',
          background: (el, s) => s.root.docFilter === 'xray' ? 'amber.15' : 'inkSurface',
          color: (el, s) => s.root.docFilter === 'xray' ? 'amber' : 'inkMuted',
          on: { click: (e, el, s) => s.root.update({ docFilter: 'xray' }) }
        },
        CtTab: {
          text: '{{ ctScans | polyglot }}',
          fontSize: 'Z',
          fontWeight: '600',
          padding: 'Y Z',
          round: 'Y',
          cursor: 'pointer',
          background: (el, s) => s.root.docFilter === 'ctScan' ? 'blue.15' : 'inkSurface',
          color: (el, s) => s.root.docFilter === 'ctScan' ? 'blue' : 'inkMuted',
          on: { click: (e, el, s) => s.root.update({ docFilter: 'ctScan' }) }
        },
        ThreeDTab: {
          text: '3D Scans',
          fontSize: 'Z',
          fontWeight: '600',
          padding: 'Y Z',
          round: 'Y',
          cursor: 'pointer',
          background: (el, s) => s.root.docFilter === 'intraoral3d' ? 'violet.15' : 'inkSurface',
          color: (el, s) => s.root.docFilter === 'intraoral3d' ? 'violet' : 'inkMuted',
          on: { click: (e, el, s) => s.root.update({ docFilter: 'intraoral3d' }) }
        },
        PhotosTab: {
          text: '{{ photos | polyglot }}',
          fontSize: 'Z',
          fontWeight: '600',
          padding: 'Y Z',
          round: 'Y',
          cursor: 'pointer',
          background: (el, s) => s.root.docFilter === 'photo' ? 'teal.15' : 'inkSurface',
          color: (el, s) => s.root.docFilter === 'photo' ? 'teal' : 'inkMuted',
          on: { click: (e, el, s) => s.root.update({ docFilter: 'photo' }) }
        }
      },

      // ─── DOCUMENT grid ────────────────────────
      DocumentGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
        gap: 'A',
        '@mobileL': { gridTemplateColumns: '1fr 1fr' },
        '@mobileS': { gridTemplateColumns: '1fr' },

        children: (el, s) => {
          const filter = s.root.docFilter || 'all'
          return SAMPLE_DOCUMENTS.filter(d => filter === 'all' || d.docType === filter)
        },
        childrenAs: 'state',
        childExtends: 'DocumentCard'
      },

      // ─── EMPTY STATE ─────────────────────────
      EmptyState: {
        display: (el, s) => {
          const filter = s.root.docFilter || 'all'
          const count = SAMPLE_DOCUMENTS.filter(d => filter === 'all' || d.docType === filter).length
          return count === 0 ? 'flex' : 'none'
        },
        flow: 'y',
        align: 'center center',
        gap: 'Z',
        padding: 'D',
        EmptyIcon: { extends: 'Icon', name: 'folder', fontSize: 'D', color: 'inkMuted' },
        EmptyText: { text: '{{ noDocumentsFound | polyglot }}', fontSize: 'A', color: 'inkMuted' }
      }
    }
  },

  // ─── DOCUMENT VIEWER OVERLAY ────────────────
  DocumentViewer: {}
}
